import { ref } from 'vue';
import api from '@/api/api';

const isVisible = ref(false);
const stage = ref(1);
const csatStatus = ref('pendente');
const shouldTrack = ref(false);
import router from '@/routes/routerConfig';

export function useCsat() {

    const checkCsatStatus = async (laboratoryId) => {
        const currentRoute = router.currentRoute.value;
        if (currentRoute.meta.hideCsat) {
            shouldTrack.value = false;
            return;
        }

        try {
            const response = await api().get('/feedback/csat/status', {
                params: { laboratory_id: laboratoryId }
            });

            csatStatus.value = response.data.status;
            shouldTrack.value = response.data.should_track;

            if (!shouldTrack.value) {
                localStorage.removeItem(`csat_activity_count_${laboratoryId}`);
            } else {
                if (csatStatus.value === 'adiado') {
                    stage.value = 2;
                }
            }
        } catch (error) {
            console.error("Erro ao verificar status do CSAT:", error);
            shouldTrack.value = false;
        }
    };

    const registerActivity = (laboratoryId) => {
        if (!shouldTrack.value) {return;
        }

        let count = parseInt(localStorage.getItem(`csat_activity_count_${laboratoryId}`) || '0');

        count++;

        localStorage.setItem(`csat_activity_count_${laboratoryId}`, count.toString());

        if (csatStatus.value === 'pendente' && count >= 3) {
            stage.value = 1;
            isVisible.value = true;
        }

        else if (csatStatus.value === 'adiado' && count >= 2) {
            stage.value = 2;
            isVisible.value = true;
        }
    };

    const submitVote = async (grade, laboratoryId) => {
        try {
            await api().post('/feedback/csat/vote', {
                grade: grade,
                stage: stage.value,
                laboratory_id: laboratoryId
            });

            csatStatus.value = 'concluido';
            shouldTrack.value = false;
            localStorage.removeItem(`csat_activity_count_${laboratoryId}`);

            return true;
        } catch (error) {
            console.error("Erro ao enviar voto CSAT:", error);
            return false;
        }
    };

    const dismissPopup = async (laboratoryId) => {
        isVisible.value = false;

        localStorage.setItem(`csat_activity_count_${laboratoryId}`, '0');

        try {
            const response = await api().post('/feedback/csat/dismiss', {
                laboratory_id: laboratoryId
            });
            csatStatus.value = response.data.new_status;

            if (csatStatus.value === 'adiado') {
                stage.value = 2;
            } else if (csatStatus.value === 'rejeitado') {
                shouldTrack.value = false;
            }

        } catch (error) {
            console.error("Erro ao fechar CSAT:", error);
        }
    };

    return {
        isVisible,
        stage,
        shouldTrack,
        checkCsatStatus,
        registerActivity,
        submitVote,
        dismissPopup
    };
}